import { getErrorMessage } from "@helper/getErrorMessage";
import { reactionCount } from "@helper/utils";
import { HandleReactionClick, ReactionProp } from "@typings/Reactions";
import { type ReactElement, useState } from "react";

import { getReactionGif } from "./helper/getReactionGif";

type ArticleReactionOptionsProps = {
  reactions: ReactionProp[];
  handleReactionClick: HandleReactionClick;
  reactionsUser: string;
  articleId: string;
  variant?: "top" | "bottom";
};

export const ArticleReactionOptions = ({
  reactions,
  handleReactionClick,
  reactionsUser,
  articleId,
  variant = "top",
}: ArticleReactionOptionsProps): ReactElement => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick: HandleReactionClick = async (reactionId, variant) => {
    setIsSubmitting(true);
    try {
      await handleReactionClick(reactionId, variant);
    } catch (err) {
      console.log("Reactions not working", getErrorMessage(err));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (reactions.length === 0) {
    return <></>;
  }

  const isBottomVariant = variant === "bottom";
  const wrapperClass = isBottomVariant
    ? "flex flex-col lg:flex-row gap-1 lg:gap-4 min-w-[349px] max-w-[488px] p-6 justify-between items-center bg-gray-500"
    : "flex w-max py-4 px-4 justify-center items-center rounded-3xl border-gray-500 border-4 bg-gray-500";

  return (
    <div
      className={wrapperClass}
      style={
        !isBottomVariant
          ? {
              boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.16)",
            }
          : undefined
      }
    >
      {isBottomVariant && (
        <div
          data-testid="reaction-prompt"
          className="text-gray-100 font-semibold font-sm leading-[140%]"
        >
          என்ன நினைக்கிறீர்கள்?
        </div>
      )}
      <ul className="flex items-start gap-1">
        {reactions.map((reaction) => (
          <li
            key={`reactions-li-${variant}-${reaction.id}-${articleId}`}
            className="w-[56px]"
          >
            <button
              disabled={isSubmitting}
              onClick={() => {
                void handleClick(reaction.id, variant);
              }}
              className="flex w-full flex-col justify-center items-center gap-1"
              aria-label={reaction.text}
            >
              <img
                src={getReactionGif(reaction.id)}
                alt={reaction.text}
                width={20}
              />
              <div
                className={`text-center font-semimedium text-sm leading-[150%]
                  ${reactionsUser === reaction.id ? "text-red-100" : "text-black-100"} 
                `}
              >
                {reactionCount(reaction.count)}
              </div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
